<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">AQAR</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a routerLink="/aqar">AQAR</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="ptb--100  verticaltab--1">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-4">
        <div class="pdfBox">
          <div class="pdf-icon">
            <span><i class="fa fa-file-pdf-o"></i></span>
          </div>
          <div class="pdf-content">
            <h4>AQAR 2020-21</h4>
            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar/AQAR-2020-21.pdf" target="_blank"
              class="cmn-button" target="_blank">Click Here</a>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="pdfBox">
          <div class="pdf-icon">
            <span><i class="fa fa-file-pdf-o"></i></span>
          </div>
          <div class="pdf-content">
            <h4>AQAR 2021-22</h4>
            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar/AQAR-2021-22.pdf" target="_blank"
              class="cmn-button" target="_blank">Click Here</a>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="pdfBox">
          <div class="pdf-icon">
            <span><i class="fa fa-file-pdf-o"></i></span>
          </div>
          <div class="pdf-content">
            <h4>AQAR 2022-23</h4>
            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar/AQAR-2022-2023.pdf" target="_blank"
              class="cmn-button" target="_blank">Click Here</a>
          </div>
        </div>
      </div>
      <!-- <div class="col-md-4">
          <div class="pdfBox">
            <div class="pdf-icon">
                <span><i class="fa fa-file-pdf-o"></i></span>
            </div>
            <div class="pdf-content">
              <h4>AQAR 2021-22</h4>
              <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-21-22.pdf" target="_blank" class="cmn-button" target="_blank">Click Here</a>
            </div>
          </div>
        </div> -->
      <!-- <div class="col-md-4">
          <div class="pdfBox">
            <div class="pdf-icon">
                <span><i class="fa fa-file-pdf-o"></i></span>
            </div>
            <div class="pdf-content">
              <h4>4.1.3</h4>
              <a href="https://drive.google.com/file/d/1C7FydrKiZeSoCYS73xyBCDMVLyT2kJjw/view?usp=sharing" class="cmn-button" target="_blank">Click Here</a>
            </div>
          </div>
        </div> -->
    </div>
  </div>
</section>
